import { render, staticRenderFns } from "./EditPhysicalTherapy.vue?vue&type=template&id=13a2bc7d&scoped=true&"
import script from "./EditPhysicalTherapy.vue?vue&type=script&lang=js&"
export * from "./EditPhysicalTherapy.vue?vue&type=script&lang=js&"
import style0 from "./EditPhysicalTherapy.vue?vue&type=style&index=0&id=13a2bc7d&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13a2bc7d",
  null
  
)

export default component.exports